import { AdductionOrder } from '@features/siteStatusV2/types';
import { convertDateFormat } from '@features/siteStatusV2/utils/helpers';
import React from 'react';
import { ClockFill, RssFill } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';

import { TranslationNamespaces } from '../../../../locales/constants/translationNamespaces.enum';
import { GridContainer } from '../display-form';
import FieldRow from './FieldRow';

const OrderClosureSection: React.FC<{ order: AdductionOrder | null }> = ({ order }) => {
  const { t } = useTranslation(TranslationNamespaces.SITE_STATUS);
  return (
    <GridContainer>
      <FieldRow
        icon={<ClockFill />}
        label={t('orderDetails.adduction.invoiceSendDate')}
        value={convertDateFormat(order?.orderCompleted.invoiceSendDate) ?? ''}
      />
      <FieldRow
        icon={<ClockFill />}
        label={t('orderDetails.adduction.invoicePaymentDate')}
        value={convertDateFormat(order?.orderCompleted.invoicePaymentDate) ?? ''}
      />
      <FieldRow
        icon={<ClockFill />}
        label={t('orderDetails.adduction.thawDate')}
        value={convertDateFormat(order?.orderCompleted.thawDate) ?? ''}
      />
      <FieldRow
        icon={<RssFill />}
        label={t('orderDetails.adduction.clientPvStatus')}
        value={order?.orderCompleted.clientPvStatus ?? ''}
      />
    </GridContainer>
  );
};

export default OrderClosureSection;
